<template>

  <div >

    <el-link :underline="false" @click="drawer = true">
      <div style="position: fixed;right: 10px;bottom: calc(50% - 20px);border: 1px #ced8e4 solid;border-radius: 100px;box-shadow: 0 0 10px 2px #bdcee0;padding: 20px;width: 20px;height: 20px">
        <el-image
          style="width: 20px; height: 20px"
          :src="require('@/assets/images/home/navi-arrow.png')"
          fit="cover"></el-image>

      </div>

    </el-link>

    <div class="nvi" align="center">

      <el-card :body-style="{ padding: '0px' ,borderRadius:'20px'}">

        <div>
          <div style="margin: 10px 15px 0 30px;float: left;">
            <el-image style="height: 44px;width: 44px"
                      :src="require('@/assets/images/home/logo.png')"
                      fit="cover"
                      @click="toHome">
            </el-image>
          </div>

          <div style="margin: 16px 20px 16px 0;float: left;font-size: 20px;height: 28px">
            小D的Studio
          </div>

          <div style="float: left">
            <el-menu  :default-active="$route.path" mode="horizontal" @select="handleSelect" active-text-color="#409EFF" style="padding: 0 0;">

              <template v-for="(menu) in navData" style="padding: 0 0">
                <el-submenu :key="menu.path" :index="menu.path" v-if="menu.children" style="padding: 0 0">
                  <template slot="title" style="padding-left: 10px">
                    <!--                  <i :class="menu.icon"></i>-->
                    <span slot="title" style="padding: 0 0">{{menu.name}}</span>
                  </template>
                  <el-menu-item v-for="menuItem in menu.children" :key="menuItem.path" :index="menuItem.path" class="nav_item_padding">
                    <!--                <i :class="menu.icon"></i>-->
                    <span slot="title">{{menuItem.name}}</span>
                  </el-menu-item>

                </el-submenu>
                <el-menu-item :key="menu.path" :index="menu.path" v-else class="nav_item_padding">
                  <!--                <i :class="menu.icon"></i>-->
                  <span slot="title" v-if="menu.name === 'PLEX'">
                    <el-image style="height: 20px;width:50px;margin-top: -3px" :src="require('@/assets/images/home/plex.png')" fit="cover">
            </el-image>
                  </span>
                  <span slot="title" v-else>{{menu.name}}</span>
                </el-menu-item>
              </template>

            </el-menu>
          </div>

          <div style="float: right">
            <div class="login_style" align="right">
              <div v-if="$store.state.isLogin === false">
                <el-link :underline="false" @click="registerClick">注册</el-link>
                <el-divider direction="vertical"></el-divider>
                <el-button @click="loginClick" type="primary" style="padding: 8px 15px ">登录</el-button>
              </div>
              <div v-else-if="$store.state.isLogin === true">
                <el-link :underline="false" @click="gpBackManage" v-if="$store.state.authType === UserAuthType_Admin">管理后台</el-link>
                <el-link :underline="false" @click="goPersonal">个人中心</el-link>
                <el-divider direction="vertical"></el-divider>
                <el-link :underline="false" @click="logOut">退出</el-link>
              </div>

            </div>
          </div>

        </div>

      </el-card>

    </div>

    <div class="body_container" v-bind:style="{minHeight: height+'px'}">
      <router-view></router-view>
    </div>

    <div class="foot_container">
      <Footer></Footer>
    </div>

    <el-backtop></el-backtop>

    <el-dialog width="30%" title="账号登录"
               :visible.sync="dialogLoginVisible"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               @closed="closeDialog('loginForm')">
      <el-form :model="loginForm" :rules="rules" ref="loginForm" :hide-required-asterisk="true">
        <el-form-item prop="username">
          <el-input v-model="loginForm.username"  prefix-icon="el-icon-user" placeholder="请输入账号" clearable></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="loginForm.password"  prefix-icon="el-icon-lock" placeholder="请输入密码" show-password clearable></el-input>
        </el-form-item>

        <el-form-item prop="code">

          <el-row :gutter="10" type="flex" justify="space-between" style="height: 40px">
            <el-col :span="12">
              <el-input v-model="loginForm.valicode"  prefix-icon="el-icon-key" placeholder="请输入验证码" clearable></el-input>
            </el-col>
            <el-col :span=7>
              <div>
                <el-image  style="width: 108px; height: 40px" :src="loginCodeImage"></el-image>
              </div>
            </el-col>

            <el-col :span="4">
              <div align="right">
                <el-link :underline="false" type="primary" @click="changeCode">看不清</el-link>
              </div>
            </el-col>
          </el-row>

        </el-form-item>

        <el-form-item>
          <el-button style="width: 100%;" type="primary" @click="loginSubmit('loginForm')">确定</el-button>
        </el-form-item>

        <el-form-item>
          <div align="right">
            <el-link :underline="false" @click="registerClick">忘记密码</el-link>
            <el-divider direction="vertical"></el-divider>
            <el-link :underline="false" @click="registerClick">注册</el-link>
          </div>
        </el-form-item>

      </el-form>

    </el-dialog>

    <el-drawer
      :visible.sync="drawer"
      direction="rtl"
      :with-header="false"
      size="85%">
      <div style="height:100%">
        <iframe
          name="iframeMap"
          id="iframeMapViewComponent"
          style="height: 100%;width: 100%"
          :src="url_frame"
          marginwidth="0"
          marginheight="0"
          frameborder="0"
          ref="iframeDom"
        ></iframe>
      </div>

    </el-drawer>

  </div>
</template>

<script>
// import NaviPage from "@/components/navigation/NaviPage";

// import bus from '../../../js/bus'
// import store from '../../../store'
// import Config from '../../../js/pc/Config'

import Config from '../../../../js/pc/Config'

import Common from '../../../../js/Common'
import Footer from './Footer'
import {userLogin, captcha} from '../../../../request/api'

export default {
  name: 'Navi',
  components: {Footer},
  // store,
  // components: {NaviPage},
  data () {
    return {
      drawer: false, // 抽屉
      url_frame: Common.url_flame,
      height: 0,
      navData: Config.navData,
      rules: {
        username: [
          {required: true, message: '账号不可为空', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '密码不可为空', trigger: 'blur'}
        ],
        valicode: [
          {required: true, message: '验证码不可为空', trigger: 'blur'}
        ]
      },
      loginForm: {
        username: '',
        password: '',
        valicode: ''
      },
      formLabelWidth: '120px',
      dialogLoginVisible: false,
      loginCodeID: '',
      loginCodeImage: '',
      UserAuthType_Admin: Common.UserAuthType.UserAuthType_Admin
    }
  },
  methods: {
    toHome () {
      if (this.$route.path === '/') {
        return
      }
      this.$router.push('/')
    },
    loginClick () {
      captcha().then(res => {
        console.log(res)

        if (res.code === '90') {
          this.loginCodeID = res.data.captchaId
          this.loginCodeImage = Common.getValiCodeImage(res.data.imageUrl)
        } else {
          this.$message.error(res.msg)
        }
      }).catch((error) => {
        console.log(error)
        this.$message.error(error)
      })

      this.dialogLoginVisible = true
    },
    closeDialog (form) {
      this.$refs[form].resetFields()
    },
    registerClick () {
      this.dialogLoginVisible = false
      this.$router.push('/register')
    },
    logOut () {
      this.$confirm('是否退出登录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        localStorage.removeItem(Common.userID)
        localStorage.removeItem(Common.userName)
        localStorage.removeItem(Common.userAuth)
        localStorage.removeItem(Common.userToken)
        this.$store.commit(Common.storeUserLogout)
        this.$router.push('/')
      }).catch(() => {

      })
    },
    goPersonal () {
      this.$router.push('/personal')
    },
    gpBackManage () {
      this.$router.push('/back/dashboard')
    },
    loginSubmit (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          var parma = {'username': this.loginForm.username, 'password': this.loginForm.password, 'valicode': this.loginForm.valicode, 'loginCodeID': this.loginCodeID}

          userLogin(parma).then(res => {
            console.log(res)
            if (res.code === '90') {
              localStorage.setItem(Common.userID, res.data.id)
              localStorage.setItem(Common.userName, res.data.username)
              localStorage.setItem(Common.userAuth, res.data.auth)
              localStorage.setItem(Common.userToken, res.data.token)

              this.$store.commit(Common.storeUserLogin)
              this.$store.commit(Common.storeUserAuthType, res.data.auth)

              this.dialogLoginVisible = false

              this.$refs[form].resetFields()

              this.$message({
                type: 'success',
                message: res.msg
              })
            } else {
              this.$message.error(res.msg)
              this.loginClick()

              this.$refs[form].resetFields()
            }
          }).catch((error) => {
            console.log(error)
            this.$message.error(error)
          })
          // var url = this.loginForm.username + '/' + this.loginForm.password + '/' + this.loginForm.code

          // userLogin(url, {}).then(res => {
          //   if (res.code === '90') {
          //     this.dialogLoginVisible = false
          //
          //     sessionStorage.setItem(Common.isLogin, '1')
          //     sessionStorage.setItem(Common.userid, res.data.id)
          //     sessionStorage.setItem(Common.username, res.data.yonghuming)
          //
          //     this.$store.commit('userLogin')
          //
          //     this.$message({
          //       type: 'success',
          //       message: res.opmsg
          //     })
          //     this.$router.push('/')
          //   } else {
          //     this.$message.error(res.opmsg)
          //   }
          // }).catch((error) => {
          //   // error
          //   console.log(222222222)
          //   console.log(error)
          // })
        } else {
          return false
        }
      })
    },
    changeCode () {
      this.loginCodeImage = Common.reloadValiCodeImage(this.loginCodeID)
    },
    handleSelect (key) {
      console.log(key)

      // if (key === '/question' || key === '/personal') {
      //   if (!this.isLogin) {
      //     this.$router.push('/login')
      //     return
      //   }
      // }

      if (key === this.$route.path) {
        return
      }
      if (key.includes('http://') || key.includes('https://')) {
        window.open(key)
      } else if (key === '/navi') {
        this.drawer = true
      } else {
        this.$router.push(key)
      }
    }
  },

  created () {
    if (localStorage.getItem(Common.userToken) === null) {
      this.$store.commit(Common.storeUserLogout)
    } else {
      this.$store.commit(Common.storeUserLogin)
    }

    this.$store.commit(Common.storeUserAuthType, parseInt(localStorage.getItem(Common.userAuth)))

    // bus.$on('goLogin', () => {
    //   this.dialogLoginVisible = true
    // })
    //
    // if (sessionStorage.getItem(Common.isLogin)) {
    //   console.log('yes')
    //
    //   if (sessionStorage.getItem(Common.isLogin) === '0') {
    //     store.commit('userLogout')
    //   } else {
    //     store.commit('userLogin')
    //   }
    // } else {
    //   console.log('mo')
    //   sessionStorage.setItem(Common.isLogin, '0')
    //   store.commit('userLogout')
    // }
    //
    // console.log(store.state.isLogin)
    // 动态设置内容高度 让footer始终居底
    this.height = document.documentElement.clientHeight - 346
    // 监听浏览器窗口变化
    window.onresize = () => { this.height = document.documentElement.clientHeight - 346 }
  },
  beforeDestroy () {
    // bus.$off('goLogin')
  }
}
</script>

<style scoped>

.nvi{
  background-color: white;
  position: fixed;
  z-index: 1600;/*mavon-editor的z-index是1500*/
  top: 0;
  /*width: calc(100% - 40px);*/
  height: 60px;
  padding: 20px;
  min-width: 1140px;
  max-width: 1880px;
  left: 0px;
  right: 0px;
  margin-left: auto;
  margin-right: auto;
  /*box-shadow: 0 15px 10px -14px #999999;*/
}

.login_style {
  margin-top: 15px;
  margin-right: 50px;
}

.body_container{
  min-width: 1100px;
  max-width: 1840px;
  margin: 100px auto 0px;
  padding: 0 40px;

}

.foot_container{
  margin: 0 auto 20px;
  padding: 0 20px;
  min-width: 1140px;
  max-width: 1880px;
}

.nav_item_padding{
  /*padding: 0 10px;*/
}

</style>

<style>

.el-drawer__body{
   overflow: hidden;
}

/*.el-menu--horizontal>.el-submenu .el-submenu__title {*/
/*  height: 60px;*/
/*  line-height: 60px;*/
/*  border-bottom: 2px solid transparent;*/
/*  color: #909399;*/
/*  font-size: 14px;*/
/*  padding-left: 10px;*/
/*  padding-right: 10px;*/
/*}*/
/*.el-menu::after{*/
/*  display: none;*/
/*  content: "";*/
/*}*/
.el-menu.el-menu--horizontal {
  border-bottom: none;
}

/*.el-dialog__body{*/
/*  padding: 30px 20px 1px 20px;*/
/*}*/

::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-track {
  --webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  border-radius: 6px;
}

::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background: rgb(93, 136, 185);
  /*background: rgb(45, 140, 240);*/
  --webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5);
}

/*::-webkit-scrollbar-thumb:window-inactive {*/
/*  background: rgba(255,0,0,0.4);*/
/*}*/

</style>



// WEBPACK FOOTER //
// src/components/pc/pages/navi/Navi.vue